import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Toolbar, Typography, Box, Card, Tabs, Tab } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import AppCard from '../../../shared_elements/components/AppCard';
import appConfig from '../../../config';
import { useSelector } from 'react-redux';
import ProjectIcon from "../../../../src/assets/img/ProjectsIcon.svg";
import RecordsIcon from "../../../../src/assets/img/RecordsIcom0.svg";
import CommvergeIcon from "../../../../src/assets/img/acumen_commverge0.png";
import FinSIcon from "../../../../src/assets/img/valuation_new1.png";
import AirworthinessManagement from "../../../assets/img/CAMO_Final_Logo.svg";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const AppSwitchModal = ({ onToggleModal }) => {
	const [value, setValue] = useState('active');
	const { permission } = useSelector((state) => state.leases);
	const appPermissions = permission?.permissions || {};

	const applications = [
		{
			label: 'Projects Management',
			description: "Efficiently plan, execute and manage Technical Projects - from Pre-purchase to Redeliveries.",
			logo: ProjectIcon,
			access: appPermissions?.is_technical,
			url: appConfig?.domain.projects,
			isBeta: false
		},
		{
			label: 'Records Dataroom',
			description: 'Centralised, secure online Documents Management System (DMS) for digitised aircraft records storage retrieval and collaboration',
			logo: RecordsIcon,
			access: appPermissions?.is_records,
			url: appConfig?.domain.records,
			isBeta: false
		},
		// {
		// 	label: 'Maintenance Claim Management',
		// 	description: 'Seamlessly track, execute and manage maintenance events across the fleet, forecast future events and process commercial claims.',
		// 	logo: logo,
		// 	access: appPermissions?.contracts,
		// 	url: appConfig?.domain.maintenance,
		// 	isBeta: false
		// },
		{
			label: 'CommVerge',
			description: 'A potent decision application for computing commercial exposure and simulating complex scenarios on ~200 aircraft - engine combinations.',
			logo: CommvergeIcon,
			access: appPermissions?.is_mr_calculator,
			url: appConfig?.domain.mrCalculator,
			isBeta: false
		},
		{
			label: 'fin-S',
			description: 'Access values for a wide variety of aircraft, powered by expertise and experience of ISTAT and ASA Certified Appraisers.',
			logo: FinSIcon,
			access: appPermissions?.is_valuation,
			url: appConfig?.domain.valuation,
			isBeta: false
		},
		{
			label: 'Airworthiness Management',
			description: 'Elevate aircraft safety and compliance with our Continuing Airworthiness Management Product. Streamline maintenance, track inspections, and ensure your fleet always soars with confidence.',
			logo: AirworthinessManagement,
			access: appPermissions?.is_camo,
			url: appConfig?.domain.camo,
			isBeta: false
		},
	]
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<>
			<Dialog fullScreen open={true} onClose={onToggleModal} slots={{ transition: Transition, }} >
				<DialogTitle sx={{ m: 0, p: 0, display: "flex", alignItems: "center", justifyContent: "space-between" }} >
					<Typography sx={{ p: 0 }} marginLeft={3} fontSize={"1.25rem"} fontWeight={500} lineHeight={1.6}>Applications</Typography>
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={onToggleModal} aria-label="close"><CloseIcon /></IconButton>
					</Toolbar>
				</DialogTitle>
				<DialogContent dividers>
					<Box sx={{ width: '100%', boxShadow: "0px 1px 3px rgba(0,0,0,0.2)", mb: 1 }}>
						<Tabs value={value} onChange={handleChange} indicatorColor="primary" sx={{ "& .MuiTab-root": { color: "#a09b9b", fontSize: '12px', fontFamily: 'Roboto-Regular' }, "& .Mui-selected": { color: "#555 !important" }, }}>
							<Tab disableRipple label="ACTIVE APPLICATION(s)" value="active" color='#555' />
							<Tab disableRipple label="INACTIVE APPLICATION(s)" value="inactive" color='#555' />
						</Tabs>
					</Box>
					{(() => {
						if (value === "active") {
							const activeApps = applications.filter(item => item.access);
							return activeApps.length ? (
								<Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
									{activeApps.map((app, idx) => (
										<Grid size={{ md: 4, xs: 12 }} key={idx} sx={{ display: 'flex' }}> <AppCard item={app} /> </Grid>
									))}
								</Grid>
							) : (
								<Box sx={{ textAlign: 'center', py: 4 }}> <Typography>No active applications available</Typography> </Box>
							);
						} else {
							const inActiveApps = applications.filter(item => !item.access);
							return inActiveApps.length ? (
								<Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
									{inActiveApps.map((app, idx) => (
										<Grid size={{ md: 4, xs: 12 }} key={idx} sx={{ display: 'flex' }}>
											<AppCard item={app} />
										</Grid>
									))}
								</Grid>
							) : (
								<Box sx={{ textAlign: 'center', py: 4 }}> <Typography>No inactive applications available</Typography> </Box>
							);
						}
					})()}
				</DialogContent>
				<DialogActions sx={{ marginRight: "10px" }}>
					<Button className='cancel-btn' disabled={false} variant="outlined" size="small" onClick={onToggleModal}> Close</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

export default AppSwitchModal